<template>
    <div class="login-page flex items-center justify-center min-h-screen">
      <div class="login-container bg-white rounded-lg shadow-lg flex max-w-4xl w-full overflow-hidden">
        <div class="login-left flex flex-col items-center justify-center w-1/2 p-8">
          <img src="@/assets/logo.png" alt="Logo" class="w-16 h-16 mb-4" />
          <h2 class="text-2xl font-semibold text-gray-700 mb-4">PulsAdmin</h2>
          <p class="text-gray-500 text-center">Админ панель для сотрудников</p>
          <img src="@/assets/illustration.jpg" alt="Illustration" class="w-3/4 mt-8" />
        </div>

        <div class="login-right flex flex-col items-center justify-center w-1/2 p-8 border-l border-gray-200">
          <h3 class="text-xl font-semibold mb-6">Войти в PulsAdmin</h3>
          <form @submit.prevent="handleLogin" class="w-full max-w-sm">
            <div class="mb-4">
              <label for="email" class="block text-gray-700">Email</label>
              <input
                v-model="email"
                type="email"
                id="email"
                placeholder="Введите свой email"
                class="w-full p-2 mt-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div class="mb-6">
              <label for="password" class="block text-gray-700">Пароль</label>
              <input
                v-model="password"
                type="password"
                id="password"
                placeholder="Больше 6 + знаков "
                class="w-full p-2 mt-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <button type="submit" class="w-full p-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
              Войти
            </button>
          </form>
        </div>
      </div>
    </div>
  </template>

  <script>
  import { login } from '@/services/authService';

  export default {
    name: "LoginPage",
    data() {
      return {
        email: '',
        password: ''
      };
    },
    methods: {
      async handleLogin() {
        try {
          const response = await login(this.email, this.password);
          localStorage.setItem('token', response.data.token);
          this.$router.push({ name: 'Главная' });
        } catch (error) {
          console.error('Ошибка авторизации:', error);
          alert('Неверные учетные данные');
        }
      }
    }
  };
  </script>

  <style scoped>
  .login-page {
    background-color: #f3f4f6;
    min-height: 100vh;
  }

  .login-container {
    border-radius: 10px;
    max-width: 1000px;
    height: 80vh;
  }

  .login-left,
  .login-right {
    background-color: #ffffff;
  }

  .login-container img {
    max-width: 100%;
  }
  </style>
